import { useStores } from "@/models";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { autorun } from "mobx";
import { useEffect, useState } from 'react';
import styles from '../index.module.scss';

import { Language } from "@/apis/address/address.interface";

interface LanguagePageProps {
  code:string,
  onClose?: (code: any) => void;
}

const LanguagePage =({code, onClose }: LanguagePageProps,)=>{
    const { countryStore } = useStores();
    const [languageType, setLanguageType] = useState<string>(code||countryStore.currentLanguageCode||'' ); // 当前语言代码
    const [languageData, setLanguageData] = useState<Language[]>([]); // 语言列表
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.stopPropagation();
        const code = (event.target as HTMLInputElement).value;
        const langConfig = languageData.find((lang) => lang.code === code);
        if (!langConfig) return;
        setLanguageType(langConfig.code);
        if(langConfig.code) {
            onClose?.(langConfig);
        }
    }
    useEffect(() => {
        const disposer = autorun(() => {
            if (countryStore.supportLanguageList && countryStore.supportLanguageList.length > 0) {
                setLanguageData(countryStore.supportLanguageList);
                setLanguageType(code?code:countryStore.currentLanguageCode);
            }
        });

        return () => {
          disposer();
        };
    },[])
    return (
        <div className={styles.languageList}>
        <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            value={languageType}
            name="radio-buttons-group"
            className={styles.select}
            onChange={handleChange}
            sx={{
                '& .MuiFormControlLabel-root': {
                    padding: '6px 8px',
                    lineHeight: '20px',
                    fontWeight: 500,
                    margin:0,
                    color:'#1A1A1A',
                    '&:hover':{
                        backgroundColor:'#F5F7FA',
                        color:'#1A1A1A',
                    },
                    '& .MuiFormControlLabel-label': {
                        fontSize: '14px',
                    },
                }
               
            }}>
            {languageData?.map((config) => (
                
                <FormControlLabel  
                    value={config.code} 
                          control={<Radio 
                            icon={<span />}
                            checkedIcon={<span />}
                            disableRipple
                            sx={{
                              p: 0,
                              mr: 0,
                              '& .MuiSvgIcon-root': { display: 'none' }
                            }}
                          />} 
                    className={
                        languageType === config.code ? styles.translate_selected : ''
                      } 
                    label={config.displayText} 
                    key={config.code} 
                />
            ))}
        </RadioGroup>
        </div>
    )
}
export default LanguagePage;